import {
  ActionReducerMap
} from '@ngrx/store';
import * as fromRoot from 'src/app/store';
import * as Actions from './actions/business-details.actions';
import * as Selectors from './selectors/business-details.selectors';
import * as State from './reducers/business-details.state';
import * as Reducer from './reducers/business-details.reducer';
import * as Effects from './effects/business-details.effects';
import * as Model from 'src/app/store/feature-stores/business-details-store/models/eligibility';

export const reducers: ActionReducerMap<State.State> = {
  appstate: fromRoot.Reducer.reducer,
  businessdetailsstate: Reducer.reducer
};

// export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];

export {
  Actions,
  Selectors,
  State,
  Effects,
  Reducer,
  Model
};